import { WrittenOffStatusIndicator } from './WrittenOffStatusIndicator';

export const WrittenOffStatusDescriptions:Map<WrittenOffStatusIndicator, string> = new Map([
  [WrittenOffStatusIndicator.WRITTEN_OFF_DATE, 'Written Off Date'],
  [WrittenOffStatusIndicator.STATUS_CODE, 'Status Code'],
  [WrittenOffStatusIndicator.PRODUCT_CODE, 'Product Code'],
  [WrittenOffStatusIndicator.STATUS_CODE_AND_PRODUCT_CODE, 'Status Code AND Product Code'],
  [WrittenOffStatusIndicator.STATUS_CODE_OR_PRODUCT_CODE, 'Status Code OR Product Code'],
  [WrittenOffStatusIndicator.STATUS_CODE_AND_WRITTEN_OFF_DATE, 'Status Code AND Written Off Date'],
  [WrittenOffStatusIndicator.STATUS_CODE_OR_WRITTEN_OFF_DATE, 'Status Code OR Written Off Date'],
  [WrittenOffStatusIndicator.PRODUCT_CODE_AND_WRITTEN_OFF_DATE, 'Product Code AND Written Off Date'],
  [WrittenOffStatusIndicator.PRODUCT_CODE_OR_WRITTEN_OFF_DATE, 'Product Code OR Written Off Date'],
  [WrittenOffStatusIndicator.STATUS_CODE_AND_PRODUCT_CODE_AND_WRITTEN_OFF_DATE, 'Status Code AND Product Code AND Written Off Date'],
  [WrittenOffStatusIndicator.STATUS_CODE_OR_PRODUCT_CODE_OR_WRITTEN_OFF_DATE, 'Status Code OR Product Code OR Written Off Date'],
]);

export default WrittenOffStatusDescriptions;
